import { StyleSheet } from 'react-native';

export const SEPARATOR_HEIGHT = 0.33;

export const designSystem = {
    colors: {
        transparent: 'transparent',
        neutralBlack: '#000000',
        neutral900: '#101114',
        neutral800: '#17181C',
        neutral700: '#1E1F24',
        neutral600: '#23242A',
        neutral500: '#2F3038',
        neutral400: '#43444F',

        neutral300: '#6D707C',
        // background - handle case by case w Brad
        // foreground color - text/icon.primary? - unless disabled or tertiary states?
        neutral200: '#959AA6', // 2 backgrounds left only - handle case by case w Brad
    },
    shareGradients: {
        whatsapp: ['#0DBE2B', '#5CF676'],
        instagram: ['#6828D3', '#EA2A7E', '#F8BA3D'],
    },
};
// use this if you need a color that has opacity < 1, but you can't add the opacity as a separate prop
// for example for a semitransparent border color
export const withOpacity = (hex, opacity) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r},${g},${b},${opacity})`;
};

export const common = StyleSheet.create({
    row: { flexDirection: 'row' },
    column: { flexDirection: 'column' },
    spaceBetweenRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' },
    wrap: { flexWrap: 'wrap' },
    justifyCenter: { justifyContent: 'center' },
    justifySpaceBetween: { justifyContent: 'space-between' },
    justifySpaceAround: { justifyContent: 'space-around' },
    justifyEvenly: { justifyContent: 'space-evenly' },
    justifyStart: { justifyContent: 'flex-start' },
    justifyEnd: { justifyContent: 'flex-end' },
    alignStart: { alignItems: 'flex-start' },
    alignEnd: { alignItems: 'flex-end' },
    alignCenter: { alignItems: 'center' },
    selfCenter: { alignSelf: 'center' },
    borderCurve: { borderCurve: 'continuous' },
    full: { width: '100%' },
    minHeight100: { minHeight: '100%' },
    halfWidth: { width: '50%' },
    thirdWidth: { width: '33%' },
    width75: { width: '75%' },
    absolute: { position: 'absolute' },
    relative: { position: 'relative' },
    // Invisible, out-of-flow, full-width copy of a single-line text for measuring whether it clips (pair with `isTextClipped`).
    measureLayer: { position: 'absolute', left: 0, right: 0, opacity: 0 },
    zIndexNegative2: { zIndex: -2 },
    zIndexNegative1: { zIndex: -1 },
    zIndex0: { zIndex: 0 },
    zIndex1: { zIndex: 1 },
    zIndex2: { zIndex: 2 },
    zIndex3: { zIndex: 3 },
    zIndex4: { zIndex: 4 },
    zIndex5: { zIndex: 5 },
    zIndex100: { zIndex: 100 },
    zIndex999: { zIndex: 999 },
    fullHeight: { height: '100%' },
    hairlineHeight: { height: SEPARATOR_HEIGHT },
    padding: { padding: 16 },
    paddingHorizontal: { paddingHorizontal: 16 },
    paddingVertical: { paddingVertical: 24 },
    noPadding: { padding: 0 },
    noOpacity: { opacity: 0 },
    noGrow: { flexGrow: 0 },
    grow: { flexGrow: 1 },
    noShrink: { flexShrink: 0 },
    flex: { flex: 1 },
    noFlex: { flex: 0 },
    backgroundColorTransparent: { backgroundColor: 'transparent' },
    backgroundColorDarkMask: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
    rotate180: { transform: [{ rotate: '180deg' }] },
    noOverflow: { overflow: 'hidden' },
    separator: { height: SEPARATOR_HEIGHT },
    marginLeftAuto: { marginLeft: 'auto' },
    pointerEventsNone: { pointerEvents: 'none' },
    pointerEventsBoxNone: { pointerEvents: 'box-none' },
    shadow: {
        shadowColor: 'rgba(0, 0, 0, 1)',
        shadowOffset: { width: 2, height: -2 },
        shadowOpacity: 0.25,
        shadowRadius: 32,
        elevation: 16,
    },
    // TODO: delete this when the new architecture is fully adopted.
    // With the new architecture, fixed sizing won’t necessarily need to be set manually.
    // For now, this is a workaround because a fix for iOS 26 removed the hardcoded Switch width and height,
    // which is causing layout issues.
    // https://github.com/facebook/react-native/issues/53537
    switchSize: { height: 31, width: 51 },
});

// ! fix for storybook-web
export const commonWeb = StyleSheet.create({
    height100vh: { height: '100vh', minHeight: '100%' },
});
